import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import {
  CustomSelect, FilterPill, NoResult, Tabs,
} from '../../../ui/atoms';
import {
  Wrapper, FiltersContainer, Filter, SelectsContainer,
  FilterPillsContainer, TabsContainer, CoursesContainer, ViewMore,
  CourseItem, AcademyContainer,
} from './style';
import Arial from '../../../ui/typography/arial';
import { getValueVocabulary } from '../../../utils/getValueVocabulary';
import { defaultOptionalStatusList, defaultTabsCourses } from '../../../utils/common';
import {
  ACADEMY_CATEGORIES_GET,
  ACADEMY_LIST_GET,
  ACADEMY_SET_FAVOURITE,
} from '../../redux/actions/academy';
import routes from '../../../routes';
import CardCourses from '../../../ui/atoms/CardCourses';
import { isArabic } from '../../../utils/locale';

const Academy = ({
  list, pager, categories, vocabulary,
  getAcademyList, setFavourite, getCategories, pushUrl,
}) => {
  const [courses, setCourses] = useState([]);
  const [defaultTabs, setDefaultTabs] = useState(defaultTabsCourses(vocabulary, 0, 0));
  const [selectedTab, setSelectedTab] = useState();
  const [selectedProgressFilter, setSelectedProgressFilter] = useState();
  const [selectedAreasFilter, setSelectedAreasFilter] = useState([]);

  const [optionProgress, setOptionProgress] = useState([]);
  const [optionAreas, setOptionAreas] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    getCategories();
    getAcademyList({ subset: false, loader: true });
  }, []);

  useEffect(() => {
    if (selectedTab && selectedTab.value !== 'all') {
      const filtered = [...list].filter(item => item.area === selectedTab.value);
      setCourses(filtered);
    } else {
      setCourses([...list]);
    }
  }, [list, selectedTab]);

  useEffect(() => {
    const formattedOptionProgress = [...defaultOptionalStatusList]
      .map(({ label, value }) => ({ label: getValueVocabulary(vocabulary[label], label), value }));

    const formattedAreas = [...(categories || [])]
      .map(({ name: label, id: value }) => ({ label, value }));

    setOptionProgress(formattedOptionProgress);
    setOptionAreas(formattedAreas);
  }, [categories, vocabulary]);

  useEffect(() => {
    const headQuarterListTotal = [...list].filter(item => item.area === 'head_quarter').length;
    const regionalListTotal = [...list].filter(item => item.area === 'regional').length;
    const tabs = defaultTabsCourses(vocabulary, headQuarterListTotal, regionalListTotal);
    setSelectedTab(tabs[0]);
    setDefaultTabs(tabs);
  }, [list, vocabulary]);

  useEffect(() => {
    const area = [...selectedAreasFilter.map(f => f.value)].toString().replace(/,/g, ';') || undefined;
    const progress = selectedProgressFilter?.value;
    getAcademyList({ area, progress, subset: false, loader: true });
  }, [selectedProgressFilter, selectedAreasFilter, getAcademyList]);

  const removeFilter = (item) => {
    const newFilters = (selectedAreasFilter || []).filter(filter => filter.value !== item);
    setSelectedAreasFilter(newFilters);
  };

  const handleOnClickViewMore = () => {
    const area = [...selectedAreasFilter.map(f => f.value)].toString().replace(/,/g, ';') || undefined;
    const progress = selectedProgressFilter?.value;
    getAcademyList({ area, progress, subset: true, loader: false });
  };

  const redirectAcademyCourseDetails = (id) => {
    pushUrl(`${routes.academy?.path || routes.optionalcourses.path}/${id}`);
  };

  return (
    <AcademyContainer arabic={isArabic()}>
      <Wrapper>
        <Arial type="sectionNotificationTitle" configuration={{ textAlign: 'center' }} vocabulary="academy">
          {getValueVocabulary(vocabulary.academy, 'Academy')}
        </Arial>

        <TabsContainer>
          <Tabs
            tabType={Tabs.TYPE.ACADEMY}
            tabs={[...defaultTabs]}
            onChange={value => setSelectedTab(value)}
            selected={selectedTab}
          />
        </TabsContainer>

        <FiltersContainer>
          <SelectsContainer>
            <Filter>
              <Arial type="newsTitle">
                {getValueVocabulary(vocabulary.filtersProgress, 'filtersProgress')}
              </Arial>
              <CustomSelect
                isClearable
                selected={selectedProgressFilter}
                options={optionProgress}
                onChange={newValue => setSelectedProgressFilter(newValue || null)}
              />
            </Filter>

            
          </SelectsContainer>

          <FilterPillsContainer>
            {(selectedAreasFilter || []).map(filter => (
              <FilterPill
                key={`filter-${filter.value}`}
                onRemove={removeFilter}
                value={filter.value}
                label={filter.label}
              />
            ))}
          </FilterPillsContainer>
        </FiltersContainer>

        {(!selectedTab || selectedTab.value === 'all') && (
          <CoursesContainer>
            {[...list].map((item) => (
              <CourseItem key={`course-${item.id}`}>
                <CardCourses
                  item={item}
                  onClickCard={() => redirectAcademyCourseDetails(item.id)}
                  onClickFavourite={() => setFavourite({ nid: item.id })}
                />
              </CourseItem>
            ))}
          </CoursesContainer>
        )}

        {selectedTab && selectedTab.value === 'head_quarter' && (
          <CoursesContainer>
            {[...list].filter((item) => item.area === selectedTab.value).map((item) => (
              <CourseItem key={`course-${item.id}`}>
                <CardCourses
                  item={item}
                  onClickCard={() => redirectAcademyCourseDetails(item.id)}
                  onClickFavourite={() => setFavourite({ nid: item.id })}
                />
              </CourseItem>
            ))}
          </CoursesContainer>
        )}

        {selectedTab && selectedTab.value === 'regional' && (
          <CoursesContainer>
            {[...list].filter((item) => item.area === selectedTab.value).map((item) => (
              <CourseItem key={`course-${item.id}`}>
                <CardCourses
                  item={item}
                  onClickCard={() => redirectAcademyCourseDetails(item.id)}
                  onClickFavourite={() => setFavourite({ nid: item.id })}
                />
              </CourseItem>
            ))}
          </CoursesContainer>
        )}

        {courses.length <= 0 && <NoResult />}

        {selectedTab?.value === 'all' && pager?.current_page < pager?.total_pages && (
          <ViewMore onClick={handleOnClickViewMore}>
            <Arial type="viewMore">{getValueVocabulary(vocabulary.viewMore, 'viewMore')}</Arial>
          </ViewMore>
        )}
      </Wrapper>
    </AcademyContainer>
  );
};

Academy.propTypes = {
  list: PropTypes.array.isRequired,
  pager: PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired,
  vocabulary: PropTypes.object.isRequired,
  getAcademyList: PropTypes.func.isRequired,
  setFavourite: PropTypes.func.isRequired,
  getCategories: PropTypes.func.isRequired,
  pushUrl: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const { data: list = [], pager = {}, categories = [] } = state.academy || {};
    const { vocabulary } = state.app;
    return { list, pager, categories, vocabulary };
  },
  dispatch => ({
    getAcademyList: ({ subset, loader, area, progress }) =>
      dispatch({ type: ACADEMY_LIST_GET._REQUEST, subset, loader, area, progress }),
    setFavourite: ({ nid }) =>
      dispatch({ type: ACADEMY_SET_FAVOURITE._REQUEST, nid }),
    getCategories: () =>
      dispatch({ type: ACADEMY_CATEGORIES_GET._REQUEST }),
    pushUrl: url => dispatch(push(url)),
  })
)(Academy);
